<template>
  <!-- pricing FAQ -->
  <div class="faq-container">
    <!-- faq标题 -->
    <p class="faq-title">Frequently asked questions</p>
    <el-collapse v-model="activeFaqNames">
      <el-collapse-item :name="index + 1" v-for="(item, index) in faqList">
        <template #title>
          <div class="faq-item-title">
            <p>{{ item.title }}</p>
          </div>
        </template>
        <div class="faq-item-content">
          <p>{{ item.content }}</p>
        </div>
      </el-collapse-item>
      <el-collapse-item>
        <template #title>
          <div class="faq-item-title">
            <p>{{ $t('bvPricing.faqList.question6.title') }}</p>
          </div>
        </template>
        <div class="faq-item-content" v-html="$t('bvPricing.faqList.question6.content')">
        </div>
      </el-collapse-item>
      <el-collapse-item>
        <template #title>
          <div class="faq-item-title">
            <p>{{$t('bvPricing.faqList.question7.title')}}</p>
          </div>
        </template>
        <div class="faq-item-content" v-html="t('bvPricing.faqList.question7.content')">
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
  <refund-modal v-model="showRefundModal" />
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { ref, defineProps } from "vue";
import { faqList } from "../../constants";
import { useSubscriptionInfo } from "@/store/modules/user";
import RefundModal from "../modal/refundmodal.vue";

const props = defineProps({
  canCancel: Boolean,
  userOperationMap: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();
const { subscriptionState } = storeToRefs(useSubscriptionInfo());
const activeFaqNames = ref(["1"]);
const showRefundModal = ref(false);

const handleRefund = () => {
  showRefundModal.value = true;
};

const handleCancel = () => {
  props.userOperationMap.subscribing({}, 1);
}
</script>

<style lang="scss" scoped>
.faq-container {
  max-width: 782px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 120px;
  margin-bottom: 449px;
  padding: 0 1.5rem;
  user-select: none;

  :deep(.el-collapse) {
    margin-top: 64px;
    border-top: none;
  }

  :deep(.el-collapse-item) {
    padding-bottom: 36px;
    padding-top: 36px;
    border-bottom: 1px solid #ebeef5;
  }

  :deep(.el-collapse-item__header) {
    height: fit-content;
    border: none;
  }

  :deep(.el-collapse-item__content) {
    padding: 0;
    padding-top: 24px;
  }

  :deep(.el-collapse-item__wrap) {
    border: none;
  }
}

.faq-title {
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 51px;
  text-align: center;
  color: #060606;
}

.faq-item-title {
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
}

.faq-item-content {
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #8f959e;
  white-space: pre-wrap;
  font-variant-numeric: tabular-nums;
  
  & a {
    cursor: pointer;
    color: #875eff;

    &:hover {
      color: #a987ff;
    }
  }
}

@media screen and (min-width: 820px) {
  .faq-container {
    padding: 0 2.25rem;
  }
}
</style>